<template>
  <div class="input-group">
    <input
      :name="field"
      :type="type"
      :placeholder="inputPlaceholder"
      v-model="model[field]"
      v-validate="field['validator']"
      required/>
    <i class="bar"></i>
    <small v-if="inputHint" class="form-text text-muted">{{ inputHint }}</small>
    <small v-for="error in validationErrors" :key="error" class="form-text text-danger">{{ error }}</small>
  </div>
</template>

<script>
import inputHelpers from './input-helpers'

export default {
  mixins: [inputHelpers]
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/fractel/components/vue-mc/form/mc-string.vue